<template>
  <section class="timeline" aria-label="연혁">

    <!-- 2026 -->
    <div class="row row--current">
      <div class="year-wrap">
        <div class="year">2026</div>
        <span class="badge">현재</span>
      </div>
      <div class="dot-wrap">
        <span class="dot" aria-hidden="true"></span>
      </div>
      <div class="events">
        <ul>
          <li>
            <span class="month">04</span>
            아트너컨설팅, 한국생산성본부(Korea Productivity Center, KPC)와 업무협약 체결
          </li>
        </ul>
      </div>
    </div>

    <!-- 2025 -->
    <div class="row">
      <div class="year-wrap">
        <div class="year">2025</div>
      </div>
      <div class="dot-wrap">
        <span class="dot" aria-hidden="true"></span>
      </div>
      <div class="events">
        <ul>
          <li>
            <span class="month">10</span>
            한국내부통제협회 - 연세대학교 상남경영원, 「글로벌 내부통제 리더십 최고위과정」 공동 개설 협약 체결
          </li>
          <li>
            <span class="month">08</span>
            한국내부통제협회 발기인대회 및 창립총회 개최
          </li>
          <li>
            <span class="month">06</span>
            국제공인 전문내부통제사(CICP, Certified Internal Control Professional) 자격증 국내 1호 취득자 배출
          </li>
          <li>
            <span class="month">05</span>
            아트너컨설팅, 국제내부통제협회 한국지부(Internal Control Institute Korea, ICI Korea)로 지정
          </li>
          <li>
            <span class="month">04</span>
            아트너컨설팅, 국제내부통제협회(Internal Control Institute, ICI)와 업무협약 체결
          </li>
        </ul>
      </div>
    </div>

  </section>
</template>

<script setup>
</script>

<style scoped>
.timeline {
  --line-color: #e2e8f0;
  --dot-size: 14px;
  --line-w: 2px;
  --col-year: 130px;
  --gap: 20px;
  --accent: #365bd6;
  --bg: #fff;

  position: relative;
  margin: 24px auto;
  font-family: 'Noto Sans KR', sans-serif;
}

/* 세로선 */
.timeline::before {
  content: "";
  position: absolute;
  left: calc(var(--col-year) + var(--gap) + (var(--dot-size) / 2) - (var(--line-w) / 2));
  top: 0; bottom: 0;
  width: var(--line-w);
  background: var(--line-color);
  z-index: 0;
}

/* 행 */
.timeline .row {
  position: relative;
  display: grid;
  grid-template-columns: var(--col-year) var(--dot-size) 1fr;
  gap: var(--gap);
  align-items: start;
  padding: 32px 0;
  border-bottom: 1.5px solid #f1f5f9;
}
.timeline .row:last-child {
  border-bottom: none;
}
.timeline .row:first-child {
  padding-top: 8px;
}

/* 첫/마지막 세로선 캡 */
.timeline .row:first-child::after,
.timeline .row:last-child::before {
  content: "";
  position: absolute;
  left: calc(var(--col-year) + var(--gap) + (var(--dot-size) / 2) - (var(--line-w) / 2));
  width: var(--line-w);
  background: var(--bg);
  z-index: 1;
  pointer-events: none;
}
.timeline .row:first-child::after {
  top: 0;
  height: 28px;
}
.timeline .row:last-child::before {
  top: calc(36px + var(--dot-size));
  bottom: 0;
}

/* 연도 */
.timeline .year-wrap {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.timeline .year {
  font-size: 1.75rem;
  font-weight: 800;
  line-height: 1;
  color: #94a3b8;
  letter-spacing: -0.02em;
  padding-top: 2px;
}
.timeline .row--current .year {
  color: #365bd6;
}

/* 현재 배지 */
.timeline .badge {
  display: none;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: #fff;
  background: #365bd6;
  border-radius: 999px;
  padding: 2px 8px;
  width: fit-content;
  text-transform: uppercase;
}
.timeline .row--current .badge {
  display: inline-block;
}

/* 점 */
.dot-wrap {
  display: flex;
  justify-content: center;
  padding-top: 4px;
  z-index: 2;
  position: relative;
}
.timeline .dot {
  width: var(--dot-size);
  height: var(--dot-size);
  border-radius: 50%;
  background: #cbd5e1;
  box-shadow: 0 0 0 3px #fff, 0 1px 4px rgba(0,0,0,.1);
  position: relative;
  flex-shrink: 0;
}
.timeline .row--current .dot {
  background: #365bd6;
  box-shadow: 0 0 0 3px #fff, 0 0 0 6px #c7d2fb;
}
.timeline .row--current .dot::after {
  content: "";
  position: absolute;
  inset: -5px;
  border-radius: 50%;
  border: 2px solid #365bd6;
  opacity: 0.35;
  animation: pulse 2s ease-in-out infinite;
}
@keyframes pulse {
  0%, 100% { transform: scale(0.85); opacity: 0.35; }
  50% { transform: scale(1.1); opacity: 0.6; }
}
@media (prefers-reduced-motion: reduce) {
  .timeline .dot::after { animation: none; }
}

/* 연도 구분선 */
.timeline .row {
  border-bottom: 1.5px solid #f1f5f9;
}
.timeline .row:last-child {
  border-bottom: none;
}

/* 이벤트 목록 */
.timeline .events ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.timeline .events li {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  line-height: 1.65;
  color: #374151;
  font-size: 0.9rem;
}

/* 월 배지 */
.timeline .month {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2.6em;
  height: 1.7em;
  padding: 0 8px;
  border-radius: 999px;
  border: 1px solid #e2e8f0;
  font-weight: 700;
  font-size: 11.5px;
  color: #475569;
  background: #f8fafc;
  flex-shrink: 0;
  margin-top: 2px;
}
.timeline .row--current .month {
  border-color: #c7d2fb;
  color: #3730a3;
  background: #eef2ff;
}

/* 모바일 */
@media (max-width: 640px) {
  .timeline {
    --col-year: 100px;
    --gap: 12px;
  }
  .timeline::before { display: none; }
  .timeline .row {
    grid-template-columns: 1fr;
    gap: 6px;
    padding: 24px 0;
  }
  .dot-wrap { display: none; }
  .timeline .year { font-size: 1.35rem; }
  .timeline .events {
    padding-left: 12px;
    border-left: 2px solid var(--line-color);
  }
  .timeline .row--current .events {
    border-left-color: #a5b4fc;
  }
  .timeline .row:first-child::after,
  .timeline .row:last-child::before { display: none; }
}
</style>